import { useEffect, useRef, useCallback } from 'react';
import { useLocation } from 'react-router-dom';

export const useScrollPosition = (tag, dependencies = []) => {
  const ref = useRef();
  const location = useLocation();
  const scrollKey = `tableScrollPosition_${tag || location.pathname}`;

  const saveScrollPosition = useCallback(() => {
    if (ref.current) {
      sessionStorage.setItem(scrollKey, ref.current.scrollTop.toString());
    }
  }, [scrollKey]);

  useEffect(() => {
    if (ref.current) {
      const savedPosition = sessionStorage.getItem(scrollKey);
      if (savedPosition) {
        ref.current.scrollTop = parseInt(savedPosition, 10);
      }
    }
  }, [scrollKey, dependencies]);

  useEffect(() => {
    return () => saveScrollPosition();
  }, [saveScrollPosition]);

  return { ref, saveScrollPosition };
};